import { Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { catchError, map, mergeMap } from 'rxjs/operators';

import {
  DEL_FAVORITE,
  DEL_FAVORITE_ERR,
  DEL_FAVORITE_OK,
  GET_FAVORITES,
  GET_FAVORITES_ERR,
  GET_FAVORITES_OK,
  PUT_FAVORITE,
  PUT_FAVORITE_ERR,
  PUT_FAVORITE_OK,
  SELECT_FAVORITE,
  SELECTED_FAVORITE,
} from '../../../store/actions';
import { Favorite } from '@shared/interfaces/favorite.interface';
import { Actions, concatLatestFrom, createEffect, ofType } from '@ngrx/effects';
import { FavoritesService } from '@components/favorites/services/favorites.service';

@Injectable()
export class FavotireEffects {
  putFavorite$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PUT_FAVORITE),
      concatLatestFrom(({ valuesToSave }) =>
        this.favoriteService.findFavoriteInStoreByName(valuesToSave.name, valuesToSave.professional),
      ),
      map(([{ valuesToSave }, favoriteInStore]) => {
        if (!favoriteInStore) return valuesToSave;
        return { ...favoriteInStore, ...valuesToSave };
      }),
      mergeMap((valuesToSave) => {

        const { gsiMultiCondition1St } = valuesToSave;
        const scope = gsiMultiCondition1St.split('#')[3];

        let result: Observable<Favorite>;

        if (
          gsiMultiCondition1St.includes('RMG') ||
          gsiMultiCondition1St.includes('RMD') ||
          gsiMultiCondition1St.includes('RMM')
        ) {
          const adaptedFavorite = this.favoriteService.adaptFavorite(valuesToSave, scope);
          result = this.favoriteService.putFavoritesV2(adaptedFavorite, scope);
        } else {
          result = this.favoriteService.putFavorites({ ...valuesToSave });
        }

        return result.pipe(
          map((favorite) => PUT_FAVORITE_OK({ favorite })),
          catchError((err) => of(PUT_FAVORITE_ERR({ payload: err }))),
        )},
      ),
    ),
  );

  loadFavotires$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GET_FAVORITES),
      mergeMap(({ gsiMultiCondition1St }) => {
        let result: Observable<Favorite[]>;

        if (
          gsiMultiCondition1St.includes('RMG') ||
          gsiMultiCondition1St.includes('RMD') ||
          gsiMultiCondition1St.includes('RMM')
        ) {
          const { professionalId, scope } = this.favoriteService.getProfessionalIdAndScope(gsiMultiCondition1St);
          result = this.favoriteService.getFavoritesByProfessionalV2({ professionalId, scope });
        } else {
          result = this.favoriteService.getFavoritesByProfessional(gsiMultiCondition1St);
        }

        return result.pipe(
          map((favorites) => GET_FAVORITES_OK({ favorites })),
          catchError((err) => of(GET_FAVORITES_ERR({ payload: err }))),
        );
      }),
    ),
  );

  deleteFavorite$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DEL_FAVORITE),
      mergeMap(({ sk }) => {
        const result = sk.includes('PRO') ?
          this.favoriteService.deleteFavorite(sk) :
          this.favoriteService.deleteFavoriteV2(sk);
        
        return result.pipe(
          map(() => DEL_FAVORITE_OK({ sk })),
          catchError((err) => of(DEL_FAVORITE_ERR({ payload: err }))),
        )},
      ),
    ),
  );

  selectFavorite$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SELECT_FAVORITE),
      mergeMap(({ favorite }) =>
        this.favoriteService.getUpdatedFavoritesContent(favorite).pipe(
          map((updatedFavorite) => SELECTED_FAVORITE(
            { favorite: { favorite: updatedFavorite.favorite, group: updatedFavorite.group } }),
          ),
          catchError((err) => of(GET_FAVORITES_ERR({ payload: err }))),
        ),
      ),
    ),
  );
  constructor(private actions$: Actions, private favoriteService: FavoritesService) { }
}
